var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0786 9.17486L20.8368 0.937744H9.18002L0.938263 9.17486V20.8251L9.18002 29.0622H20.8368L29.0786 20.8251V9.17486Z",
    fill: "url(#paint0_radial_44_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0786 9.17486L20.8368 0.937744H9.18002L0.938263 9.17486V20.8251L9.18002 29.0622H20.8368L29.0786 20.8251V9.17486Z",
    fill: "url(#paint1_radial_44_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20635 0.92606L9.16 0.946655L14.0885 12.0238L14.1348 12.0032L9.20635 0.92606Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2817 1.58175L10.7951 4.55139L10.8103 4.59977L20.2968 1.63013L20.2817 1.58175Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4943 1.57783L18.2141 6.46228L18.2601 6.48371L20.5403 1.59926L20.4943 1.57783Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.803 4.55159L10.7905 4.60071L18.2353 6.50139L18.2479 6.45228L10.803 4.55159Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2218 6.45593L14.0896 11.9969L14.1303 12.0272L18.2624 6.48622L18.2218 6.45593Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2518 6.45494L18.2236 6.49707L25.7337 11.5194L25.7619 11.4772L18.2518 6.45494Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.683 9.66742L25.7959 11.5679L25.8237 11.6102L28.7109 9.70975L28.683 9.66742Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 11.5411L14.2461 11.9617L14.248 12.0124L25.6686 11.5918L25.6667 11.5411Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.954 11.7744L25.9062 11.7915L28.872 20.0443L28.9197 20.0272L25.954 11.7744Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.708 11.7675L23.1394 18.9516L23.1872 18.9687L25.7557 11.7846L25.708 11.7675Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.173 18.9455L23.1599 18.9945L28.8595 20.5183L28.8726 20.4693L23.173 18.9455Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1367 12.0116L14.0873 12.0232L15.1815 16.6956L15.2309 16.6841L14.1367 12.0116Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2115 16.6642L15.1975 16.713L23.1618 18.9923L23.1758 18.9435L15.2115 16.6642Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2271 16.6739L15.1815 16.6961L18.2463 22.9758L18.2919 22.9536L15.2271 16.6739Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1437 18.9395L18.2523 22.9435L18.2844 22.9827L23.1758 18.9788L23.1437 18.9395Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2915 22.9593L18.2448 22.979L20.8135 29.0663L20.8603 29.0466L18.2915 22.9593Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2527 22.9466L12.612 25.9125L12.6356 25.9574L18.2763 22.9915L18.2527 22.9466Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6366 25.9106L12.6195 25.9583L20.1794 28.6647L20.1965 28.6169L12.6366 25.9106Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6106 25.9154L9.03264 28.9089L9.0652 28.9477L12.6432 25.9543L12.6106 25.9154Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1773 16.6803L12.5999 25.9254L12.6487 25.939L15.2261 16.6939L15.1773 16.6803Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19062 18.9705L5.15604 19.0076L12.6071 25.9485L12.6417 25.9114L5.19062 18.9705Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1965 16.6584L5.1622 18.9613L5.17355 19.0107L15.2079 16.7078L15.1965 16.6584Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15998 18.9666L0.72113 20.7954L0.740459 20.8423L5.17931 19.0135L5.15998 18.9666Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18426 9.22344L1.15405 9.26416L6.50486 13.2292L6.53507 13.1885L1.18426 9.22344Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7806 4.56579L6.49826 13.2028L6.5437 13.2253L10.8261 4.5883L10.7806 4.56579Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52891 13.1891L6.51007 13.2361L15.1907 16.7065L15.2096 16.6594L6.52891 13.1891Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49879 13.2059L5.14938 18.9812L5.19877 18.9927L6.54818 13.2174L6.49879 13.2059Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0.957372 9.16414L0.910797 9.1842L5.14315 18.9982L5.18972 18.9781L0.957372 9.16414Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8031 5.05205C11.0646 5.05205 11.2765 4.84023 11.2765 4.57894C11.2765 4.31765 11.0646 4.10583 10.8031 4.10583C10.5417 4.10583 10.3297 4.31765 10.3297 4.57894C10.3297 4.84023 10.5417 5.05205 10.8031 5.05205Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1251 12.4612C14.3865 12.4612 14.5984 12.2494 14.5984 11.9881C14.5984 11.7268 14.3865 11.515 14.1251 11.515C13.8636 11.515 13.6517 11.7268 13.6517 11.9881C13.6517 12.2494 13.8636 12.4612 14.1251 12.4612Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1614 19.4396C23.4228 19.4396 23.6348 19.2278 23.6348 18.9665C23.6348 18.7052 23.4228 18.4934 23.1614 18.4934C22.8999 18.4934 22.688 18.7052 22.688 18.9665C22.688 19.2278 22.8999 19.4396 23.1614 19.4396Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.207 17.1586C15.4685 17.1586 15.6804 16.9467 15.6804 16.6854C15.6804 16.4242 15.4685 16.2123 15.207 16.2123C14.9456 16.2123 14.7336 16.4242 14.7336 16.6854C14.7336 16.9467 14.9456 17.1586 15.207 17.1586Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51738 13.6862C6.77882 13.6862 6.99075 13.4744 6.99075 13.2131C6.99075 12.9518 6.77882 12.74 6.51738 12.74C6.25594 12.74 6.04401 12.9518 6.04401 13.2131C6.04401 13.4744 6.25594 13.6862 6.51738 13.6862Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17335 19.465C5.43479 19.465 5.64673 19.2531 5.64673 18.9918C5.64673 18.7306 5.43479 18.5187 5.17335 18.5187C4.91192 18.5187 4.69998 18.7306 4.69998 18.9918C4.69998 19.2531 4.91192 19.465 5.17335 19.465Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6289 26.4094C12.8903 26.4094 13.1022 26.1976 13.1022 25.9363C13.1022 25.675 12.8903 25.4632 12.6289 25.4632C12.3674 25.4632 12.1555 25.675 12.1555 25.9363C12.1555 26.1976 12.3674 26.4094 12.6289 26.4094Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2671 23.4441C18.5285 23.4441 18.7404 23.2323 18.7404 22.971C18.7404 22.7097 18.5285 22.4979 18.2671 22.4979C18.0056 22.4979 17.7937 22.7097 17.7937 22.971C17.7937 23.2323 18.0056 23.4441 18.2671 23.4441Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2503 6.95299C18.5117 6.95299 18.7236 6.74117 18.7236 6.47988C18.7236 6.21859 18.5117 6.00677 18.2503 6.00677C17.9888 6.00677 17.7769 6.21859 17.7769 6.47988C17.7769 6.74117 17.9888 6.95299 18.2503 6.95299Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8411 12.0304C26.1026 12.0304 26.3145 11.8186 26.3145 11.5573C26.3145 11.296 26.1026 11.0842 25.8411 11.0842C25.5797 11.0842 25.3678 11.296 25.3678 11.5573C25.3678 11.8186 25.5797 12.0304 25.8411 12.0304Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18005 1.87553C9.69826 1.87553 10.1183 1.45568 10.1183 0.937764C10.1183 0.419851 9.69826 0 9.18005 0C8.66185 0 8.24176 0.419851 8.24176 0.937764C8.24176 1.45568 8.66185 1.87553 9.18005 1.87553Z",
    fill: "#1EA7DA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0.938293 10.0873C1.4565 10.0873 1.87659 9.66747 1.87659 9.14956C1.87659 8.63164 1.4565 8.21179 0.938293 8.21179C0.420088 8.21179 0 8.63164 0 9.14956C0 9.66747 0.420088 10.0873 0.938293 10.0873Z",
    fill: "#1EA7DA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8453 1.87553C21.3635 1.87553 21.7836 1.45568 21.7836 0.937764C21.7836 0.419851 21.3635 0 20.8453 0C20.3271 0 19.907 0.419851 19.907 0.937764C19.907 1.45568 20.3271 1.87553 20.8453 1.87553Z",
    fill: "#1EA7DA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0617 10.0873C29.5799 10.0873 30 9.66747 30 9.14956C30 8.63164 29.5799 8.21179 29.0617 8.21179C28.5435 8.21179 28.1234 8.63164 28.1234 9.14956C28.1234 9.66747 28.5435 10.0873 29.0617 10.0873Z",
    fill: "#1EA7DA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0.938293 21.7544C1.4565 21.7544 1.87659 21.3346 1.87659 20.8167C1.87659 20.2988 1.4565 19.8789 0.938293 19.8789C0.420088 19.8789 0 20.2988 0 20.8167C0 21.3346 0.420088 21.7544 0.938293 21.7544Z",
    fill: "#1EA7DA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0617 21.7544C29.5799 21.7544 30 21.3346 30 20.8167C30 20.2988 29.5799 19.8789 29.0617 19.8789C28.5435 19.8789 28.1234 20.2988 28.1234 20.8167C28.1234 21.3346 28.5435 21.7544 29.0617 21.7544Z",
    fill: "#1EA7DA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18002 30C9.69823 30 10.1183 29.5801 10.1183 29.0622C10.1183 28.5443 9.69823 28.1245 9.18002 28.1245C8.66182 28.1245 8.24173 28.5443 8.24173 29.0622C8.24173 29.5801 8.66182 30 9.18002 30Z",
    fill: "#1EA7DA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8453 30C21.3635 30 21.7836 29.5801 21.7836 29.0622C21.7836 28.5443 21.3635 28.1245 20.8453 28.1245C20.3271 28.1245 19.907 28.5443 19.907 29.0622C19.907 29.5801 20.3271 30 20.8453 30Z",
    fill: "#1EA7DA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1707 8.91302C25.6635 8.87078 25.2916 8.87923 25.2916 8.87923H21.9188L19.9662 8.88768H9.95771H8.10648H4.74215C4.30259 8.87923 3.86303 8.92147 3.86303 8.92147C2.81485 8.99751 1.91882 9.14113 1.91882 9.14113C2.96701 9.31009 3.86303 9.36079 3.86303 9.36923C4.37022 9.41148 4.74215 9.40303 4.74215 9.40303H8.11494H9.96616H19.9662H21.9188H25.2916C25.7312 9.41148 26.1707 9.36079 26.1707 9.36079C27.2189 9.28475 28.1149 9.14113 28.1149 9.14113C27.0752 8.98061 26.1707 8.92147 26.1707 8.91302Z",
    fill: "#E63634"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45062 25.0408V21.7544L9.44217 19.8789V10.1127V8.27092V4.98453C9.45062 4.55366 9.40836 4.1228 9.40836 4.1228C9.33228 3.0921 9.18012 2.22192 9.18012 2.22192C9.00261 3.24417 8.94344 4.1228 8.94344 4.1228C8.90117 4.6128 8.90963 4.98453 8.90963 4.98453V8.27937V10.1211V19.8789L8.91808 21.7544V25.0408C8.90963 25.4717 8.95189 25.9026 8.95189 25.9026C9.02797 26.9248 9.18012 27.8034 9.18012 27.8034C9.34918 26.7812 9.41681 25.911 9.41681 25.9026C9.45908 25.4041 9.45062 25.0408 9.45062 25.0408Z",
    fill: "#E63634"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1792 20.5886C25.672 20.5463 25.3001 20.5548 25.3001 20.5548H21.9273H19.9831H9.97466L8.12344 20.5632H4.75065C4.31109 20.5548 3.87153 20.597 3.87153 20.597C2.82335 20.673 1.92732 20.8167 1.92732 20.8167C2.97551 20.9856 3.87153 21.0363 3.87153 21.0448C4.37872 21.087 4.75065 21.0786 4.75065 21.0786H8.12344L9.97466 21.0701H19.9747H21.9189H25.2917C25.7312 21.0786 26.1708 21.0363 26.1708 21.0363C27.219 20.9603 28.115 20.8167 28.115 20.8167C27.0753 20.6477 26.1877 20.597 26.1792 20.5886Z",
    fill: "#E63634"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1074 25.0408V21.7544L21.099 19.8789V10.1211V8.27935V4.99295C21.1074 4.56208 21.0651 4.13122 21.0651 4.13122C20.9891 3.10052 20.8369 2.23035 20.8369 2.23035C20.6678 3.25259 20.6002 4.13122 20.6002 4.13122C20.558 4.62122 20.5664 4.99295 20.5664 4.99295V8.27935V10.1211V19.8789L20.5749 21.7544V25.0408C20.5664 25.4717 20.6087 25.9026 20.6087 25.9026C20.6848 26.9332 20.8369 27.8034 20.8369 27.8034C21.006 26.7896 21.0736 25.911 21.0736 25.9026C21.1159 25.4041 21.1074 25.0408 21.1074 25.0408Z",
    fill: "#E63634"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18002 10.0873C9.69823 10.0873 10.1183 9.66747 10.1183 9.14956C10.1183 8.63164 9.69823 8.21179 9.18002 8.21179C8.66182 8.21179 8.24173 8.63164 8.24173 9.14956C8.24173 9.66747 8.66182 10.0873 9.18002 10.0873Z",
    fill: "#E63634"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8706 10.0873C21.3888 10.0873 21.8089 9.66747 21.8089 9.14956C21.8089 8.63164 21.3888 8.21179 20.8706 8.21179C20.3524 8.21179 19.9323 8.63164 19.9323 9.14956C19.9323 9.66747 20.3524 10.0873 20.8706 10.0873Z",
    fill: "#E63634"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8706 21.7544C21.3888 21.7544 21.8089 21.3346 21.8089 20.8167C21.8089 20.2988 21.3888 19.8789 20.8706 19.8789C20.3524 19.8789 19.9323 20.2988 19.9323 20.8167C19.9323 21.3346 20.3524 21.7544 20.8706 21.7544Z",
    fill: "#E63634"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18852 21.7544C9.70673 21.7544 10.1268 21.3346 10.1268 20.8167C10.1268 20.2988 9.70673 19.8789 9.18852 19.8789C8.67032 19.8789 8.25023 20.2988 8.25023 20.8167C8.25023 21.3346 8.67032 21.7544 9.18852 21.7544Z",
    fill: "#E63634"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_44_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0117 15.0011) scale(13.833 13.8252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1541,
    stopColor: "#ABDEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3067,
    stopColor: "#9FD8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5761,
    stopColor: "#7DCBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9285,
    stopColor: "#34BAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B6E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_44_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0117 15.0011) scale(14.4908 14.4827)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1541,
    stopColor: "#ABDEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3055,
    stopColor: "#9FD7E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5728,
    stopColor: "#7ECAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9224,
    stopColor: "#36B7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08B3E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.029c1316.svg";
export { ForwardRef as ReactComponent };